import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import Input from "antd/es/input/Input";
// import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
// import Table from "../../../../components/Datatable/DataTable";
// import config from "../../../../config/config";
// import Loader from "../../../../components/Loader/Loader";
import DeleteConfirmationModal from "../../../../components/Modal/UnDeleteConfirmation";
import { Link } from "react-router-dom";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import { checkUserPermission } from "../../../../common/UserPermission";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { toastSuccess } from "../../../../common/Toast";
import { DELETE_MESSAGE } from "../../../../common/Constant";

const DeletedItems = (props) => {
  let selectData = [];
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("asc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState([]);
  const [selectedItemsCheckboxIDs, setselectedItemsCheckboxIds] = useState("");

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      setSelectedRows(e.selectedRows.map((x) => x.ID));
      selectData[currentPage] = e.selectedRows.map((x) => x.ID);
      console.log(e.selectedRows.map((x) => x.ID));

      const selectedItemsCheckboxIDs =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedItemsCheckboxIds(selectedItemsCheckboxIDs);
      console.log(selectedItemsCheckboxIDs);
    }
  };

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );
    axios
      .get(
        // api in not made
        `${
          config.itemsBaseUrl
        }/items/managedelete?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res", res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  }, [
    perPageSize,
    searchtext,
    sortingId,
    sortingDirection,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
  ]);

  const handleDeletePopup = (id, rows, field) => {
    let data;
    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.ID).join(",");
    } else {
      data = id;
    }
    const deleteRequestParam = {
      itemids: data,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true);
  };

  const contextActions = useMemo(() => {
    // const handleDeletePopup = () => {
    //   const deleteRequestParam = {
    //     itemids: selectedItemsCheckboxIDs,
    //   };
    //   localStorage.setItem(
    //     "DeleteRequestParam",
    //     JSON.stringify(deleteRequestParam)
    //   );
    // };
    return (
      <button
        type="button"
        className="btn btn-success btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#UnDeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Un Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  // Table Data
  // const columns = [
  //   {
  //     name: "ID",
  //     selector: row => row["ID"],
  //     sortable: true,
  //   },
  //   {
  //     name: "UPC/EAN/ISBN",
  //     selector: row => row["UPC/EAN/ISBN"],
  //     sortable: true,
  //   },
  //   {
  //     name: "Name",
  //     selector: (row) => row.Name,
  //     sortable: true,
  //   },
  //   {
  //     name: "Category Full Path",
  //     selector: row => row["CategoryFullPath"],
  //     sortable: true,
  //   },
  //   checkUserPermission('show-cost-price')&&
  //   {
  //     name: "Cost Price",
  //     selector: row => row["Costprice"],
  //     sortable: true,
  //   },
  //   {
  //     name: "Selling Price",
  //     selector: row => row["Unitprice"],
  //     sortable: true,
  //   },
  //   {
  //     name: "Quantity",
  //     selector: row => row["TotalRecord"],
  //     sortable: true,
  //   },
  //   {
  //     name: "",
  //     selector: row => row["Image"],
  //     sortable: true,
  //   },
  // ];

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
    },
    {
      header: "UPC/EAN/ISBN",
      accessorKey: "UPC/EAN/ISBN",
    },
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "Category Full Path",
      accessorKey: "CategoryFullPath",
    },
    checkUserPermission("show-cost-price") && {
      header: "Cost Price",
      accessorKey: "Costprice",
      Cell: ({ row }) => parseFloat(row.original.Costprice).toFixed(2),
    },
    {
      header: "Selling Price",
      accessorKey: "Unitprice",
      Cell: ({ row }) => parseFloat(row.original.Unitprice).toFixed(2),
    },
    {
      header: "Quantity",
      accessorKey: "TotalRecord",
    },
    // {
    //   header: "",
    //   accessorKey:"Image"
    // },
  ]);

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };
  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
    console.log(handleListData);
  };
  // const rowSelectCritera = row => row.fat > 6;

  // const clickHandler = (e) => {
  //     console.log(e.target.id);
  // }
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Deleted Items</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items List</Link>
                </li>
                <li className="breadcrumb-item active">Deleted Items List</li>
              </ul>
            </div>
          </div>

          <div className="row flex-row-reverse">
            {/* <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              />
            </div> */}
          </div>

          {/* Customer list */}
          {/* <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  title="Deleted Items List"
                  columns={columns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  selectableRows
                  sortServer
                  onSort={handleSort}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                />
              </div>
            </div>
          </div> */}

          <MaterialReactTable
            columns={columns}
            data={data}
            enableColumnResizing
            // enableRowActions
            enableGrouping
            enableStickyHeader
            enableStickyFooter
            enableRowSelection
            enableColumnOrdering
            initialState={{
              density: "compact",
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 25 },
              sorting: [{ id: "state", desc: false }], //sort by state by default
            }}
            // muiToolbarAlertBannerChipProps={{ color: "primary" }}
            // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
            muiTablePaginationProps={{
              rowsPerPageOptions: [25, 50, 100, 300, 500],
            }}
            muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
            // manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: "Error loading data",
                  }
                : undefined
            }
            // onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={totalRows}
            state={{
              // columnFilters,
              globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
              >
                <Button
                  size="small"
                  disabled={
                    !table.getIsSomeRowsSelected() &&
                    !table.getIsAllRowsSelected()
                  }
                  //only export selected rows
                  onClick={() =>
                    handleDeletePopup(
                      "",
                      table.getSelectedRowModel().rows,
                      "multipleRowInactive"
                    )
                  }
                  // startIcon={<FileDownloadIcon />}
                  variant="contained"
                >
                  UnDelete
                </Button>
                <Button
                  size="small"
                  onClick={() =>
                    // setPagination({ ...pagination, pageSize: totalRows })
                    setPagination({
                      ...pagination,
                      pageIndex: 0,
                      pageSize: totalRows,
                    })
                  }
                  variant="contained"
                >
                  Get All Data
                </Button>
              </Box>
            )}
          />
        </div>
      </div>

      <DeleteConfirmationModal
        deleteApiUrl={`${config.itemsBaseUrl}/items/undeletemutiple`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default DeletedItems;
